import loadable from '@loadable/component'

export default [
  {
    path: '/NewYearUnionGameV2',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGameV2" */ '~/pages/NewYearUnionGameV2'
        )
    ),
  },
  {
    path: '/NewYearUnionGameV2/giftbanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGameV2" */ '~/pages/NewYearUnionGameV2/giftbanner'
        )
    ),
  },
  {
    path: '/NewYearUnionGameV2/cardModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGameV2" */ '~/pages/NewYearUnionGameV2/cardModal'
        )
    ),
  },
  {
    path: '/NewYearUnionGameV2/animateModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGameV2" */ '~/pages/NewYearUnionGameV2/animateModal'
        )
    ),
  },
]
